import { render } from "./PersonalTraining.vue?vue&type=template&id=29717846"
import script from "./PersonalTraining.vue?vue&type=script&lang=js"
export * from "./PersonalTraining.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__